const dossierAttachmentSchema = function (state, props) {
  return {
    "ui:readonly": props.readonly,
    "ui:order": ["time", "*"],
    "title" : {
      "ui:widget": "hidden"
    },
    "text": {
      "ui:widget": "hidden"
    },
    "dossierItemType": {
      "ui:widget": "hidden"
    },
    "consultationId": {
      "ui:widget": "hidden"
    },
    "dossierId": {
      "ui:widget": "hidden"
    },
    "time": {
      "ui:visible":  !props.hideTime,
      "ui:group": "line",
      "ui:options": {
        "ui:width": 2,
        "label": false
      },
    },
    "attachment": {
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:widget": "FileWidget"
    },
    "attachmentTitle": {
      "ui:widget": "hidden"
    },
  }
}

export default dossierAttachmentSchema;
